document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        if (event.target.matches('.play-track')) {
            event.preventDefault();

            var embedStart = 'https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&hide_artwork=1&mini=1&autoplay=1&feed=%2F';
            var trackUrl = event.target.getAttribute('data-mixcloud-play-button');
            var cleanedUrl = trackUrl.replace(/^https:\/\/www\.mixcloud\.com\//, '');
            var iframeUrl = embedStart + encodeURIComponent(cleanedUrl); // Append autoplay parameter

            // Create a new iframe element
            var newIframe = document.createElement('iframe');
            newIframe.src = iframeUrl;
            newIframe.setAttribute('id', 'mixcloud-player__iframe');
            newIframe.setAttribute('allow', 'autoplay');

            // Get the parent container
            var playerContainer = document.getElementById('mixcloud-player');

            // Remove any existing iframe
            var existingIframe = playerContainer.querySelector('iframe');
            if (existingIframe) {
                playerContainer.removeChild(existingIframe);
            }

            // Append the new iframe to the player container
            playerContainer.appendChild(newIframe);
            playerContainer.classList.add('visible');
        }
    });
});
